import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
  ReferenceDataDomain,
} from "@duosoftbg/nacid-components";
import { getReferenceDataOptions } from "../../../../services/coreServicesCalls";

const sliceName = "appData/seRecognitionPurpose";
const seRecognitionPurposeSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(seRecognitionPurposeThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(seRecognitionPurposeThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(seRecognitionPurposeThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const seRecognitionPurposeThunk = createAsyncThunk(
  `${sliceName}/seRecognitionPurposeThunk`,
  async () => {
    const response = await getReferenceDataOptions(ReferenceDataDomain.SEC_EDU_RECOGNITION_PURPOSE)();
    return response;
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.SeRecognitionPurpose);
    },
  },
);

export default seRecognitionPurposeSlice.reducer;
